import { SignIn } from '@clerk/clerk-react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;

export const LoginPage = () => (
    <Container>
        <SignIn signUpUrl="/sign-up" path="/login" />
    </Container>
);
